import React from "react";
import MeetTeamContent from "../function-components/MeetTeamFolder/MeetTeamContent";

function MeetTeam() {
  return (
    <>
      <MeetTeamContent />
    </>
  );
}

export default MeetTeam;
